import {PlayerReduxState} from "../types";
import {getChallenge, isExamStage, isIntroStage, isPreview} from ".";

export default function canSkipLevel(state: PlayerReduxState): boolean | null | undefined {
  const challenge = getChallenge(state);
  const preview = isPreview(state);
  const examStage = isExamStage(state);
  const isIntro = isIntroStage(state);

  return isIntro
    && (preview || challenge.hasPassed)
    && !examStage
}
